import React from 'react';

import { MoneyMapperSectionOverrideFooter } from './MoneyMapperSectionOverrideFooter';
import type { MoneyMapperGuideMonthlyBills } from './useMoneyMapperGuideMonthlyBills';

export interface MonthlyBillsFooterProps {
    guideTotal: MoneyMapperGuideMonthlyBills;
    isSaving: boolean;
}

const BILLS_TITLE = 'Monthly bills';

export const MonthlyBillsFooter = ({
    guideTotal,
    isSaving,
}: MonthlyBillsFooterProps) => {
    const {
        effectiveMonthlyBillsCents,
        sourcesTotalCents,
        manualDiffersFromSourcesTotal,
        showActualBillsSubline,
        isSavingGuide,
        isEditingGuideTotal,
        guideDraftStr,
        setGuideDraftStr,
        commitGuideTotal,
        removeManualGuideTotal,
        beginGuideInputEdit,
        cancelGuideInputEdit,
        canEditMoneyMapBills,
    } = guideTotal;

    return (
        <MoneyMapperSectionOverrideFooter
            accentColor="$dropletBlue500"
            title={BILLS_TITLE}
            sheetTitle={BILLS_TITLE}
            effectiveCents={effectiveMonthlyBillsCents}
            sourcesTotalCents={sourcesTotalCents}
            manualOverrideActive={manualDiffersFromSourcesTotal}
            showSourcesSubline={showActualBillsSubline}
            sourcesSublinePrefix="Total from listed bills:"
            isSaving={isSaving}
            isSavingEdit={isSavingGuide}
            isEditing={isEditingGuideTotal}
            draftStr={guideDraftStr}
            setDraftStr={setGuideDraftStr}
            commitEdit={commitGuideTotal}
            removeManualOverride={removeManualGuideTotal}
            beginEdit={beginGuideInputEdit}
            cancelEdit={cancelGuideInputEdit}
            editDisabled={!canEditMoneyMapBills}
        />
    );
};
